import { IonModal } from '@ionic/react';
import styled from 'styled-components';

export const WrapperDiv = styled.div`
  width: 100%;

  .error {
    font-size: 0.9em;
    color: var(--ion-color-danger);
  }

  ion-skeleton-text {
    width: 100%;
    margin-top: 1rem;
  }
`;

export const IonModalWrapper = styled(IonModal)`
  ion-list {
    ion-item {
      padding-left: 10px;
      padding-right: 20px;
    }
  }

  .toolbarButton {
    --box-shadow: none;
    font-size: 0.8rem;
    margin-left: 5px;
  }

  .toolbarSearch {
    font-size: 1rem;
    margin: 0.5rem;
  }

  .loadingSpinnerContainer {
    position: absolute;
    z-index: 1000;
    left: 0;
    right: 0;
    top: 0;
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }

  .col-padding {
    padding-top: 0;
    padding-bottom: 0;
  }
`;